var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"alert",class:("alert--" + _vm.type)},[_c('div',{staticClass:"alert__title"},[_vm._v(_vm._s(_vm.type))]),_c('div',{staticClass:"alert__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }